import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "inset-gutter-10px",
  id: "app"
}
const _hoisted_2 = { class: "view-wrapper" }
const _hoisted_3 = { class: "feedback-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("footer", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", {
      class: _normalizeClass(["no-gutter", {mobile: $setup.isMobile}])
    }, [
      _withDirectives(_createVNode($setup["NavBar"], { class: "navBarTop" }, null, 512 /* NEED_PATCH */), [
        [_vShow, $setup.useNavbar]
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["page-container", {'card-base': $setup.useCardBase}])
        }, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component, route }) => [
              (route.meta.transition)
                ? (_openBlock(), _createBlock(_Transition, {
                    key: 0,
                    name: (route.meta.transition as string | undefined),
                    mode: "in-out"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_KeepAlive, null, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                          key: route.meta.usePathKey ? route.path : undefined
                        }))
                      ], 1024 /* DYNAMIC_SLOTS */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["name"]))
                : _createCommentVNode("v-if", true),
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: route.meta.usePathKey ? route.path : undefined
              }))
            ]),
            _: 1 /* STABLE */
          })
        ], 2 /* CLASS */),
        ($setup.showFeedback)
          ? (_openBlock(), _createBlock($setup["Feedback"], {
              key: 0,
              onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.showFeedback = false))
            }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "borderless feedback",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showFeedback = true))
          }, "Feedback")
        ])
      ])
    ], 2 /* CLASS */),
    _hoisted_4
  ]))
}